<template>
  <div class="flex h-screen justify-between">
    <Link :href="login()">
      <SpectreLogo class="absolute left-8 top-8 w-40" />
    </Link>
    <slot />
  </div>
  <SpectreToastGroup />
</template>

<script setup lang="ts">
import {
  SpectreLogo,
  SpectreToastGroup,
  useToasts,
} from '@agentsoftware/spectre-ui';
import { Link, usePage } from '@inertiajs/vue3';
import { whenever } from '@vueuse/core';
import { login } from '@/routes';

const { enqueue } = useToasts();

const page = usePage();

whenever(() => page.props.flash.toasts, (newValue) => {
  newValue?.forEach((toast) => {
    enqueue({ label: toast.label, description: toast.description, type: toast.type });
  });
}, { immediate: true });
</script>
